import { axiosAssessmentInstance } from "../AxiosConfiguration";

/**
 * Presence (APS) member APIs — core-lambda `/api/v4/presence/*`.
 *
 * The Daily Check-In is the hub of Presence (APS §9): consolidated follow-ups
 * are folded into it rather than fired as their own notifications, so
 * submitting a check-in is also what closes them.
 */

const unwrap = (res) => {
  const data = res?.data;
  if (data && typeof data === "object") return data.payload ?? data;
  return data;
};

/**
 * `GET /api/v4/presence/daily-check-in` — today's composed check-in.
 *
 * Returns `{ check_in_id, local_date, timezone, sequence, state,
 * checked_in_today, completed_at, can_check_in_again, pending_follow_ups[],
 * prompts[2..4], estimated_seconds }`. The prompts are AI-selected across
 * Current State / Main Influence / Reflection (Journey §10) and each carries an
 * `input` affordance (`scale_or_text` | `choice_or_text` | `text`).
 *
 * Not called on Journey Home load: the card renders from `todays_check_in`,
 * which `getJourneyHome()` already carries. This fires only when the member
 * opens the check-in.
 */
export const getDailyCheckIn = async () => {
  const res = await axiosAssessmentInstance.get("/api/v4/presence/daily-check-in");
  return unwrap(res);
};

/**
 * `POST /api/v4/presence/daily-check-in` — record the check-in.
 *
 * `responses` is keyed by prompt `key`, `follow_up_responses` by `presence_id`.
 * `reflection` is the member's Reflection-group answer, which is the line the
 * Home card shows back to them. `check_in_id` binds the submission to the
 * composition that was displayed. Returns the check-in's new state, so the
 * caller can render "Completed" without a second read.
 */
export const submitDailyCheckIn = async ({
  checkInId,
  responses,
  reflection,
  followUpResponses,
} = {}) => {
  const res = await axiosAssessmentInstance.post(
    "/api/v4/presence/daily-check-in",
    {
      check_in_id: checkInId,
      responses: responses || {},
      reflection: reflection || null,
      follow_up_responses: followUpResponses || {},
    }
  );
  return unwrap(res);
};
